// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zK2m","icon":"styles_icon__38Aup"};